import { render, staticRenderFns } from "./fileManage.vue?vue&type=template&id=4052c8a1&scoped=true&"
import script from "./fileManage.vue?vue&type=script&lang=js&"
export * from "./fileManage.vue?vue&type=script&lang=js&"
import style0 from "./fileManage.vue?vue&type=style&index=0&id=4052c8a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4052c8a1",
  null
  
)

export default component.exports